import { format } from 'date-fns/format';
import { useState } from 'react';
import { toast } from 'sonner';

import { useApiQuery, useFetch, useTableDataQuery } from '@/modules/common';

import { EventParticipant, EventParticipantsResponse } from '../types';

const currentDate = format(new Date(), 'yyyy-MM-dd');

export function useEventParticipants(eventId: string, eventName: string) {
  const fetchClient = useFetch();
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);

  const getGenerateReportUrl = async () => {
    setIsGeneratingReport(true);
    try {
      const response = await fetchClient(
        `/events/${eventId}/participants/report-csv`,
        {
          method: 'GET',
          asFormData: true,
          responseType: 'blob',
        }
      );
      const blob = new Blob([response], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `${eventName}_report_${currentDate}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsGeneratingReport(false);
    }
  };

  const uploadEventParticipants = async (file: File) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      await fetchClient(`/events/${eventId}/participants`, {
        body: formData,
        method: 'PATCH',
        asFormData: true,
      });
    } catch (error) {
      toast.error(error.message);
    }
  };

  return {
    isGeneratingReport,
    getGenerateReportUrl,
    uploadEventParticipants,
  } as const;
}
